import { coloredBooleanColumn } from "src/components/common/dataGrid/columns.tsx";
import { AavoGridColDef } from "src/components/common/dataGrid/types";
import { ShopOrderSchedulingDto } from "src/api/generated/erp/production/productionPlanning/shopOrderSchedulingDto.ts";

export const getSalvosShopOrderSchedulingCustomColumns = (): AavoGridColDef<ShopOrderSchedulingDto>[] => {
	return [
		coloredBooleanColumn({
			field: "tenantBooleanCustomColumn1" as any,
			headerName: "HK",
			afterColumn: "sourceDescription",
			width: 50,
			falseColor: "red",
		}),
		coloredBooleanColumn({
			field: "tenantBooleanCustomColumn2" as any,
			headerName: "ML",
			afterColumn: "tenantBooleanCustomColumn1" as any,
			width: 50,
			falseColor: "red",
		}),
	];
};
